import type {
    ComposableOptionsBase,
    ProductComparisonGroup
} from '~/types';
import type {
    CustomPagination,
    PaginatedPayload,
    PaginatedRequest
} from 'x1-base/types';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import { omit as lo_omit } from 'es-toolkit';
import type { NitroFetchOptions } from 'nitropack';
import type { NuxtError } from '#app';

export interface UseProductComparisonGroupsOptions extends ComposableOptionsBase {}
export function useProductComparisonGroups(options: Partial<UseProductComparisonGroupsOptions> = {}) {
    const apiBasePath = `/v1/comparison-groups`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch({ siteContext: options.siteContext });

    async function getComparisonGroups(
        args?: PaginatedRequest
    ): Promise<PaginatedPayload<ProductComparisonGroup> | NuxtError> {
        const url = `${apiBasePath}/`;
        const config: NitroFetchOptions<string> = {};

        if (args?.params) {
            config.query = args?.params;
        }

        let paginatedPayload: PaginatedPayload<ProductComparisonGroup>;

        try {
            const response = await $_fetch<CustomPagination<ProductComparisonGroup>>(url, config);

            paginatedPayload = {
                pagination: lo_omit(response, ['results']),
                data: response.results
            };

            return paginatedPayload;

        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }

    return {
        getComparisonGroups
    };
}
